/*
 * @Description: 养成-成本概览
 * @Author: zcy
 * @Date: 2022-01-10 15:20:58
 * @LastEditors: zcy
 * @LastEditTime: 2022-01-19 09:46:15
 */
import http from "@/axios/index";
/**接口根路经标识 */

export function initPageList(data) {
  const url = `/outSaleCostOrg/searchOutSaleCostOrgList`
  return http.post(url, data)
}

// 获取所有机构--成本概览
export function getAllJiGou(rootId){
  const url = `/desktopReport/queryCostOrgFish/${rootId}`
  return http.get(url)
}

// 获取所有造次次--实时存塘量
export function getAllPiCi(rootId){
  const url = `/desktopReport/queryCostPerioyFish/${rootId}`
  return http.get(url)
}
// 获取所有品类--实时存塘量
export function getAllPinLei(rootId){
  const url = `/desktopReport/queryCostBreedFish/${rootId}`
  return http.get(url)
}
// 获取所有品种--实时存塘量
export function getAllPinZhong(rootId){
  const url = `/desktopReport/queryCostTypeFish/${rootId}`
  return http.get(url)
}

